/**
 * The build identity of this bundle.
 *
 * `__APP_VERSION__` is substituted by Vite at build time (see vite.config.ts),
 * which is why this works identically in `vite dev` and in a production build
 * made from a source archive with no `.git` — nothing here depends on env files
 * being present.
 */

/** e.g. `0.1.0-97cebd`, or `0.1.0-97cebd-dirty` from a tree with local edits. */
export const APP_VERSION: string = __APP_VERSION__;

/**
 * Which deployment this is. Written by scripts/deploy.sh from ENV_NAME; absent
 * when the app is served from a workstation, which is itself the answer.
 */
export const APP_ENV: string = import.meta.env.VITE_APP_ENV ?? "local";

/**
 * What the version badge shows.
 *
 * Production shows the bare version. Everywhere else names the environment,
 * because the single most common use for this string is someone pasting a
 * screenshot into a bug report — and "which environment was that?" is the first
 * question it otherwise provokes.
 */
export function versionLabel(): string {
  return APP_ENV === "prod" ? APP_VERSION : `${APP_VERSION} · ${APP_ENV}`;
}
